module.exports = __webpack_public_path__ + "media/images/responsive/fairs/event_detail/studio_tour-c3a183b78c3f6a8c5b87f1c09e770cb0.jpg";